import React from "react";
import { Navigate } from "react-router-dom";
import { RouteGuard } from "../../../components/route-guard";
import { MERCHANT_ROLES } from "../appRouteMatchers";
import { useAppContext } from "../../AppRootProviders";
import MerchantDashboardLayout from "../../../features/MERCHANT/MerchantDashboardLayout";
import { useAuthSession } from "../../../features/auth/shared";
import {
  getMerchantDashboardRedirect,
  hasMissingMerchantOnboardingStage,
} from "../../../features/auth/merchant-register/utils/merchantOnboarding";
import { MerchantOnboardingSessionRecovery } from "../../../features/auth/merchant-register/components/MerchantOnboardingSessionRecovery";

const MerchantRouteLayout: React.FC = () => {
  const { merchantOnboardingStage, user } = useAuthSession();
  const onboardingRedirect = getMerchantDashboardRedirect(user?.role, merchantOnboardingStage);

  if (hasMissingMerchantOnboardingStage(user?.role, merchantOnboardingStage)) {
    return <MerchantOnboardingSessionRecovery />;
  }

  if (onboardingRedirect) {
    return (
      <Navigate
        to={onboardingRedirect}
        replace
      />
    );
  }

  return (
    <RouteGuard allowedRoles={MERCHANT_ROLES}>
      <MerchantDashboardLayout />
    </RouteGuard>
  );
};

export default MerchantRouteLayout;
